import moment from 'moment/moment';
import React from 'react';

import { DatePicker } from '../../common/DatePickerCompat';

interface PresenceModalProps {
  open: boolean;
  propertyName: string;
  onClose: () => void;
  onConfirm: (isPresent: boolean) => void;
  requiresDate?: boolean;
  selectedDate?: string; // YYYY-MM-DD
  onChangeDate?: (date: string) => void;
}

const PresenceModal: React.FC<PresenceModalProps> = ({ open, propertyName, onClose, onConfirm, requiresDate = false, selectedDate = '', onChangeDate }) => {
  if (!open) {return null;}
  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50">
      <div className="w-[90%] max-w-[520px] rounded-lg bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between border-b pb-3">
          <h2 className="text-xl font-semibold text-slate-900">Confirmer votre présence</h2>
          <button onClick={onClose} className="text-xl text-slate-500 hover:text-slate-700">×</button>
        </div>
        <p className="mb-6 text-slate-700">Serez-vous présent à l'AG de <strong>{propertyName}</strong> ?</p>

        {requiresDate && (
          <div className="mb-5">
            <div className="mb-3 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700">
              Aucune <strong>date d'AG prévue</strong> n'est renseignée. Veuillez sélectionner une date pour continuer.
            </div>
            <label className="mb-1 block text-sm text-slate-700">Date AG prévue</label>
            <DatePicker
              value={selectedDate ? moment(selectedDate, 'YYYY-MM-DD') : null}
              onChange={(newValue) => {
                if (!newValue || !moment(newValue).isValid()) { return; }
                const iso = moment(newValue).format('YYYY-MM-DD');
                if (onChangeDate) {
                  onChangeDate(iso);
                }
              }}
              format="DD/MM/YYYY"
              minDate={moment().startOf('day')}
              views={['day']}
              slotProps={{
                textField: { size: 'small' },
                popper: { sx: { zIndex: 10001 } },
              }}
            />
          </div>
        )}
        {!requiresDate && selectedDate && (
          <div className="mb-5">
            <label className="mb-1 block text-sm text-slate-700">Date AG prévue</label>
            <div className="rounded border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
              {(() => {
                try {
                  const d = new Date(selectedDate);
                  if (!isNaN(d.getTime())) {
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    return `${dd}/${mm}/${yyyy}`;
                  }
                } catch { /* ignore */ }
                if (/^\d{4}-\d{2}-\d{2}/.test(selectedDate)) { return selectedDate.slice(0, 10).split('-').reverse().join('/'); }
                return selectedDate;
              })()}
            </div>
          </div>
        )}
        <div className="flex justify-center gap-3">
          <button
            onClick={() => onConfirm(true)}
            className="rounded-md bg-green-600 px-4 py-2 text-white hover:bg-green-700"
            disabled={requiresDate && !selectedDate}
            title={requiresDate && !selectedDate ? 'Sélectionnez une date' : ''}
          >
            <span role="img" aria-label="check mark">✓</span> Oui, je serai présent
          </button>
          <button
            onClick={() => onConfirm(false)}
            className="rounded-md bg-red-600 px-4 py-2 text-white hover:bg-red-700"
            disabled={requiresDate && !selectedDate}
            title={requiresDate && !selectedDate ? 'Sélectionnez une date' : ''}
          >
            <span role="img" aria-label="cross mark">✗</span> Non, je serai absent
          </button>
          <button onClick={onClose} className="rounded-md bg-slate-100 px-4 py-2 text-slate-700 hover:bg-slate-200">Annuler</button>
        </div>
      </div>
    </div>
  );
};

export default PresenceModal;


